import GENERIC_RELATIONS_CONFIG from '@/components/base_components/generic-relations-wrapper/configuration/GENERIC_RELATIONS_CONFIG';

export const getAttributesIds = (attributes) => [...new Set(attributes?.map(item => item.substring(0, item.indexOf(':'))))]

export const getFlatInputConfig = (name) => GENERIC_RELATIONS_CONFIG.get(name).CONFIG
        ?.map(items => items.inputs)
        ?.flat()
        ?.filter(item => item.isFilter)
